var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSerendipity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.4922,
    cy: 12.1367,
    r: 10,
    fill: "white",
    stroke: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14453,
    y: 3.98633,
    width: 14.6942,
    height: 16.3003,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.992188,
    y: 0.636719,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.130171) scale(0.0163109 0.0147038)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 377,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXkAAABkBAMAAACREl3/AAAAG1BMVEXtMSTtMSRBQUFBQUFBQUFgPTnFNClBQUHtMST9BaxbAAAAB3RSTlPZYZHcRRMAP812CQAACVlJREFUeNrtm0tz4jgQgOGwUz7CISmOWwyx78PD1y3i2NeEgMnRGEvsGQO+kkO2+Nnb3ZJsyTZTecww5SpcS1a0Zfyp3d1qtTwt3uAjal3pr/RX+iv9lf5Kf6W/0r+P/qnbandvmkn/1DrR0Q6bR886J3Ucb5pGz3on7bhpGL0Bfzr91Sj6RxP+dLxtEP3qVD5eG0Tfq9CfvjWGvqp6sJ2wKfQ1qm+E4xJ9nepB+Q2hr1V9Eywf6VkB3O52rAaFHaSPFG7rxswYwibQ90q6fmyM6QA9q4TITlNMB+hVxClyA2Y1JOoA/UtV0VFlQJwnXn/w8Ik7sMWC88UirAprjkW9vL57F+l7VVJuVQw/cTM4Bh+nD7I0ZG62NYROltZ27pU4cnGNGTx1b4C+zsal474Vo3cyOuwP08OFIcvq6JN+338v/alG9d1u1JJm/59xZlUe0rOAL0F8jT7Ossnndb/qdrodRV+6yCq5LdrN8FPKr6WHn/s6fQvoo9rw0jPnqwRtns3gpvvP0PNp3/QY+v41et7h7aj1UhvaI/OJwI12wn52n6KvPb5I30Wv7ZX80zB8FXTW4kaJsgCmRTAWViQLrWHS693iqh2W6JkMtETPwpIYI2avNimop1eRb+pmP/DGcb8fztxdSYJtCiYxNgKk74OlQIixZ/LUtN/n/e9Z9qPv96EJR59sy6BfQX3pSMUlpO9AW4g7J9WMWlad06r0QaPfFrMJBaAUfnaTZWJAuQQ6oo+QgdEUsQuU14KqBypsodfKEEwOzJm4RKeXM/6roH/McayC7By97PNWPOQsD86JuO8IWdNnxBFTGd4fJGJmgJEsqeFq9EM1Z2DEFNfY0MvPfUCnfywmfKC3VGyJtCzmnfSMdDsQlrcUTBmxugimJCHqPp/WXCkt6OE3xCA1emGUaxqDQW/hcsMiLaN1Ez+NRIhv30/PhULTgQjW6QMLEJBYf4xKEm8OvQ9IK6Qa/Sic0SCRfgHN8SKMsS8PhG9r9IyMJqJ5tIcFJqz2fUOwI7nlfx+gj7PcXBJSVoKhH1nvqH0oJGQ/0NyofgV9KvTg53OtrSxeJj4avQBkxNCj9orGQ/RiaD+jb3f0QHqfW4R8yA4ASWdei9AnJRM5PQSqX0G/U531TIHc3hUTia77bjck4rdcTOAWVVlF0no+5hzluPPpUXkm3P4BYg8CrMXcKyWBkNik8J0yBp1+r+YonV4GpUPdbIXWIuhV4CQfaN+q/P5cvKeHpE9ijPhTGUqoKZWeS7JQo5fGoEdMOePtDXoMOmriMuN9h1T7ls+1NAgKRUfBf36uPZbp4cbouzj9mKxn6bd19KxMvxaBxy/Tr6w8TdfptWkgp6/Jc/56LAbleZ5aotgmq/9R3bP8XPEwJkuZTpQi5unYrdDTXCutJWr9W5tjvpjLEzEhEgrSDzw6eEGvST5qOfDjh0DmT2bMOXZDVqWHBKd1UjEnqq3dWCa9SrU24imHRQLhF//jefj5kNeiiTky89bo/yX1ripeq6oegn5VV7tRdQaN3la6l8Y+L3QvJYmp+6WQuj+LmLaau2WurNG/UNOImGgirNX6RtoV9KxuXRuV6JciB6OpB/6MuYjQkj4RWpXxXtGLcGrMVvgwjNlqIp+XeniUBuBxI+kjRf9G7VcVxhW9MpK6moKRpW29KSU1lBcspnhrZTKGRNEj98PCMTOFRZEpoGDr+XIeD81dkFek/6a4MVO4ecozhVBOu1pF5K1G9YXQVVHlUISYMKdXEl+nl7mRmaVlRZYmBKj9LFMFEo0+wqjeUhFTzzfBmy2BBvRRda/EqtCrmkLq5znPtnDXRJfk9OKa4bkMWVwlUgy14NToVxqDypBfNZe8NSuBheXLOuZNt3vLzSRTuNm9GsdGre2elUSnpxrQdqnRjx1tdUIxQOUKkwq9aLdl8zXKrbtT7OxgDdkq1f2eauqAnH0HxQ3vZMo2HFIzzutJU0PC+n38koDQx7Uiw3UfpsLxcJivDOk3h3KulgvcTlcekIhBdGm1Ye3dxgV4m3Xwm+jUUk2kfzH3aFenU22Jh5+pPb73iM+WU4Jivvh4/X5lvp9wlv6Lxxl65s3dM1XN9+1bFZs9lLo9XpQ+X8R/ll7b5j/iZGFdnH7yBXpWv2d4QXr/C/RntjwvRp8O+Ffo2SXomefVqnjufXpvUr5l8XgB+t+1V37GdppDv7KaTF/3pkWD6PmT1TT6xNPex6wYzy+jn9cEGzNnYj8JOwmeC41L5vgVUr9/tLdJmf6CyK+kX9YEele7L6Tah/ogSwtHSCNi/BQbdw4t7wfeP63ypnRx/LJXRFha/am+lmL6PK7filz6dLUgX46Lx0GbG7PB40Xeov55ChmczRM2vnxM69ToRvRV3f82+gVsW2FRYhCCiU99NPQHnvgM1jIs8EI0aewAm3LTO1k1vYMzAyQOQh44UIcIoYuPXTykXySD2d8XonfGLu0QubsYtoZSH5Tp3mW2M0yhApvajk35ThinqsjjpJmdZCmVaaH+s7H5EAuR0D2dZUAPnjD3ogvRz9Idc8PNhGXM2fLgwFz+nI4WsGm058FD+HzgwYgHE+a4/novLonhzB06zPrAt/ihLnvo8gD0js8v9a8HUp6kqEPQoMcDm7Mtd3iccuajCaPXHtA34ROMOaOlCrxMsxVeC8NIdvjhssueJ/tkyy9IjyFvY2PwI+/LwBVRxOdTSR/vyT+hLejBLhS9YI8P5KtOCKNPts7kovR7pAerCdH7ABPoIcZ/T4eSfn0g/4STgv4+HSp6RnazOcTUxYfuiVzPXJYe9i92On289ZXlEJqT0ydQHFL0PEWf3dga/W79B3SP7wqEaDmpoN9M0H6InszC5YoetM1yegdjZuAry0F6al+W3p+T7mx0VUFv880eIyLAQnENXFHRi3FtxGo9GMJwYM5yQ+xC9CLTuAj9LLOJfrQczSFmpB6Ed/eOLGc+3Ppr/C8MtihGeqwoJlvPhTpcSu/xrbfis4QuE0m/HMXjy9AH7h5uBaxU+nfusfh0v4snWOkcu+DLk8T1xesa39EpJlQ3HeNgKPbHMk8TXe6BfgTxFhRyEXp8n0akuAx06YgEl0TwnVF+zKgtskpKl/FMKDJj8ZeEuIBn4ssC/vyBf+vm/LrXm6/0HzzuG03/W1blV/or/ZX+Sn+lv9Jf6a/0Ffr/AdDATmua4kOPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSerendipity);
export default __webpack_public_path__ + "static/media/pin_serendipity.a81858f7e388d389599a3eaea874ba4c.svg";
export { ForwardRef as ReactComponent };